// DataStorage.js

const cardData = [
    {
      category: 'men',
      imageSrc: 'https://images.unsplash.com/photo-1516082669438-2d2bb5082626?q=80&w=2069&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
      buttonText: "Shop Men's Things",
    },
    {
      category: 'women',
      imageSrc: 'https://images.unsplash.com/photo-1629977008298-926046be0a8b?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
      buttonText: "Shop Women's Things",
    },
    {
      category: 'kids',
      imageSrc: 'https://plus.unsplash.com/premium_photo-1661537986432-6091aa4aec43?q=80&w=2071&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
      buttonText: "Shop Kids' Things",
    },
  ];
  
  export default cardData;
  